import React from 'react';
import { HomeHero, HomeStats } from '../components/home/HomeHero';
import { HomeServices } from '../components/home/HomeServices';
import { HomeCrew, HomeReasons, HomeReviews } from '../components/home/HomeCommunity';
import { HomeLocations } from '../components/home/HomeLocations';
import { ShopGallery } from '../components/ShopGallery';
import '../styles/reference-home.css';

export default function RedesignedHome() {
  return (
    <div className="reference-home" data-testid="redesigned-homepage">
      <HomeHero />
      <HomeStats />
      <HomeServices />
      <HomeReasons />
      <HomeCrew />
      <ShopGallery />
      <HomeReviews />
      <HomeLocations />
    </div>
  );
}